const EnumGroup = {
  GUEST: "Guest",
  AUTHOR: "Author",
  REVIEWER: "Reviewer",
  EDITOR: "Editor",
  ASSISTANT: "Assistant",
  WEBMASTER: "Webmaster",
  ASSOCIATE_EDITOR: "AssociateEditor",
};

export default EnumGroup;
